import { cn } from "@/lib/utils";

export function CarouselDots({
  count,
  active,
  onSelect,
  label = "slide",
  className,
}: {
  count: number;
  active: number;
  onSelect?: (index: number) => void;
  label?: string;
  className?: string;
}) {
  const dot = (i: number) => (
    <span
      aria-hidden
      className={cn(
        "block h-1.5 rounded-full transition-all duration-300",
        i === active ? "bg-teal-07 w-8" : "bg-teal-03 w-2",
      )}
    />
  );

  return (
    <div
      className={cn("flex items-center justify-center pt-4", className)}
      {...(onSelect ? {} : { "aria-hidden": true })}
    >
      {Array.from({ length: count }).map((_, i) =>
        onSelect ? (
          <button
            key={i}
            type="button"
            onClick={() => onSelect(i)}
            aria-label={`Go to ${label} ${i + 1}`}
            aria-current={i === active ? "true" : undefined}
            className="flex h-6 min-w-6 cursor-pointer items-center justify-center"
          >
            {dot(i)}
          </button>
        ) : (
          <span key={i} className="flex h-6 min-w-6 items-center justify-center">
            {dot(i)}
          </span>
        ),
      )}
    </div>
  );
}
